import React, { useState, useEffect } from "react";

const UnitCountSeven = () => {
  const [statistics, setStatistics] = useState({
    totalAssets: 0,
    totalValue: 0,
    totalDepreciation: 0,
    netBookValue: 0,
    byCategory: [],
    byCondition: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem('authToken');

      if (!apiUrl || !token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${apiUrl}/assets/statistics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.success) {
        // Convert snake_case to camelCase
        setStatistics({
          totalAssets: data.data.total_assets || 0,
          totalValue: data.data.total_value || 0,
          totalDepreciation: data.data.total_depreciation || 0,
          byCategory: data.data.by_category || [],
          byCondition: data.data.by_condition || []
        });
      }
    } catch (err) {
      console.error('Failed to fetch statistics:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  return (
    <div className='col-12'>
      <div className='card radius-12'>
        <div className='card-body p-16'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-xl-4 col-sm-6'>
              <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-1 left-line line-bg-primary position-relative overflow-hidden'>
                <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                  <div>
                    <span className='mb-2 fw-medium text-secondary-light text-md'>
                      Total Assets
                    </span>
                    <h6 className='fw-semibold mb-1'>
                      {loading ? '...' : statistics.totalAssets}
                    </h6>
                  </div>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-primary-100 text-primary-600'>
                    <i className='ri-inbox-archive-fill' />
                  </span>
                </div>
                <p className='text-sm mb-0 text-secondary-light'>
                  Total number of assets in inventory
                </p>
              </div>
            </div>
            <div className='col-xxl-3 col-xl-4 col-sm-6'>
              <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-2 left-line line-bg-lilac position-relative overflow-hidden'>
                <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                  <div>
                    <span className='mb-2 fw-medium text-secondary-light text-md'>
                      Total Value
                    </span>
                    <h6 className='fw-semibold mb-1'>
                      {loading ? '...' : formatCurrency(statistics.totalValue)}
                    </h6>
                  </div>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-lilac-200 text-lilac-600'>
                    <i className='ri-money-dollar-circle-fill' />
                  </span>
                </div>
                <p className='text-sm mb-0 text-secondary-light'>
                  Total original cost of all assets
                </p>
              </div>
            </div>
            <div className='col-xxl-3 col-xl-4 col-sm-6'>
              <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-3 left-line line-bg-success position-relative overflow-hidden'>
                <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                  <div>
                    <span className='mb-2 fw-medium text-secondary-light text-md'>
                      Total Depreciation
                    </span>
                    <h6 className='fw-semibold mb-1'>
                      {loading ? '...' : formatCurrency(statistics.totalDepreciation)}
                    </h6>
                  </div>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-success-200 text-success-600'>
                    <i className='ri-line-chart-fill' />
                  </span>
                </div>
                <p className='text-sm mb-0 text-secondary-light'>
                  Accumulated depreciation amount
                </p>
              </div>
            </div>
            <div className='col-xxl-3 col-xl-4 col-sm-6'>
              <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-4 left-line line-bg-warning position-relative overflow-hidden'>
                <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                  <div>
                    <span className='mb-2 fw-medium text-secondary-light text-md'>
                      Net Book Value
                    </span>
                    <h6 className='fw-semibold mb-1'>
                      {loading ? '...' : formatCurrency(statistics.totalValue - statistics.totalDepreciation)}
                    </h6>
                  </div>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-warning-focus text-warning-600'>
                    <i className='ri-wallet-3-fill' />
                  </span>
                </div>
                <p className='text-sm mb-0 text-secondary-light'>
                  Current value after depreciation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountSeven;
